// extracted by mini-css-extract-plugin
var _1 = "AqqFu0jA";
var _2 = "A86PRlFM";
var _3 = "A86PRlFM";
export { _1 as "footnote", _2 as "product-details", _3 as "productDetails" }
